const envs = {
  images: process.env.REACT_APP_IMAGES_PATH,
  urlAPI: process.env.REACT_APP_URL_API
}

export default envs;